// Opcion B (stock por mercado) sobre el filtro nativo de "Tallas":
// no se registra ningun filtro ni metacampo nuevo. El filtro de Tallas de
// Shopify sigue funcionando de forma 100% nativa (contador y paginacion
// reales). Justo despues de que Shopify pinte el grid de productos, si hay
// alguna talla seleccionada en el filtro nativo (inputs "filter.v.option.*"),
// ocultamos en el propio navegador las tarjetas de producto que no tengan
// stock de esa talla en el mercado detectado (window.sucursalActiva). Usa el
// mismo dato "data-loc-inv" (metacampo inventary.by_location) que ya pinta
// cada tarjeta y que usa geoloc-inventory.js para deshabilitar tallas sin
// stock en la ficha de producto. Sin ninguna talla seleccionada no se oculta
// nada: el listado se comporta exactamente igual que hoy.
function applyMarketStockToGrid() {
  const gridContainer = document.getElementById('ProductGridContainer');
  if (!gridContainer) return;

  const selectedTallas = Array.from(
    document.querySelectorAll('input[name^="filter.v.option."]:checked')
  ).map((input) => input.value);

  const cards = gridContainer.querySelectorAll('.grid__item');
  // Si por orden de carga esta funcion se ejecuta antes de que
  // geoloc-inventory.js asigne window.sucursalActiva, usamos "WEB" (el mismo
  // valor por defecto que asigna ese script) en vez de tratarlo como
  // "mercado desconocido" -> eso evitaba ocultar nada y mostraba productos
  // sin stock durante una fraccion de segundo (o de forma persistente si la
  // geolocalizacion nunca llegaba a resolver).
  const sucursalActiva = window.sucursalActiva || 'WEB';

  cards.forEach((card) => {
    if (selectedTallas.length === 0) {
      card.style.removeProperty('display');
      return;
    }

    const variantEl = card.querySelector('[data-loc-inv]');
    if (!variantEl) {
      // Producto sin selector de tallas (variante unica): el filtro nativo de
      // Tallas ya lo habria excluido si no coincide, asi que no lo tocamos.
      card.style.removeProperty('display');
      return;
    }

    let locInventory = null;
    try {
      locInventory = JSON.parse(variantEl.getAttribute('data-loc-inv'));
    } catch (e) {
      locInventory = null;
    }

    const hasStock = Array.isArray(locInventory) && selectedTallas.some((talla) =>
      locInventory.some(
        (inv) =>
          inv.variant_title === talla &&
          inv.location_name === sucursalActiva &&
          inv.available_quantity > 0
      )
    );

    card.style.display = hasStock ? '' : 'none';
  });
}
window.applyMarketStockToGrid = applyMarketStockToGrid;

// Ajusta el contador visible ("36 productos", "Mostrando 36 de 44
// productos", ...) para que refleje las tarjetas que quedan realmente
// visibles tras aplicar applyMarketStockToGrid(). Sin ninguna talla
// seleccionada no tocamos el contador: es el nativo de Shopify y ya es
// exacto. Con una talla seleccionada, sustituye solo el PRIMER numero del
// texto (el conteo filtrado) y deja intacto cualquier segundo numero (el
// total sin filtrar, en formatos tipo "X de Y productos").
function updateVisibleProductCount() {
  const gridContainer = document.getElementById('ProductGridContainer');
  if (!gridContainer) return;

  const selectedTallas = Array.from(
    document.querySelectorAll('input[name^="filter.v.option."]:checked')
  ).map((input) => input.value);

  if (selectedTallas.length === 0) return;

  const visibleCount = Array.from(gridContainer.querySelectorAll('.grid__item')).filter(
    (card) => card.style.display !== 'none'
  ).length;

  const countContainers = [
    document.getElementById('ProductCount'),
    document.getElementById('ProductCountDesktop'),
    // Contador del cajon de filtros movil ("FILTROS (N productos de un
    // total de M)"): no tiene id propio, solo la clase .mobile-facets__count.
    document.querySelector('.mobile-facets__count'),
  ].filter(Boolean);

  countContainers.forEach((container) => {
    // Guardamos el texto nativo de Shopify la primera vez, para poder
    // recalcular siempre a partir de el (y no de un texto ya ajustado por
    // nosotros, que podria haber perdido el numero total original).
    if (container.dataset.nativeCountText === undefined) {
      container.dataset.nativeCountText = container.textContent;
    }
    container.textContent = container.dataset.nativeCountText.replace(/\d+/, String(visibleCount));
  });
}
window.updateVisibleProductCount = updateVisibleProductCount;

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        updateVisibleProductCount();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    updateVisibleProductCount();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    applyMarketStockToGrid();
  }

  static renderProductCount(html) {
    // Esta plantilla de coleccion no usa #ProductCount (solo el contador del
    // cajon de filtros movil, .mobile-facets__count, que ya se actualiza en
    // renderAdditionalElements). Si #ProductCount no existe en el fragmento
    // recibido, salimos sin hacer nada en vez de lanzar una excepcion: antes
    // este metodo rompia con "Cannot read properties of null (reading
    // 'innerHTML')" en cada cambio de filtro, lo que cortaba la ejecucion y
    // dejaba sin llamar a updateVisibleProductCount() justo despues.
    const parsedCount = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    if (!parsedCount) return;

    const count = parsedCount.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
      delete container.dataset.nativeCountText;
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
      delete containerDesktop.dataset.nativeCountText;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const target = document.querySelector(selector);
      target.innerHTML = html.querySelector(selector).innerHTML;
      // El texto que acaba de pintar Shopify es el nativo (sin ajustar por
      // stock/mercado): que updateVisibleProductCount() lo vuelva a tomar
      // como referencia la proxima vez que se llame.
      if (selector === '.mobile-facets__count') delete target.dataset.nativeCountText;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class DoubleRange extends HTMLElement {
  inRangeColor = "#949494";
  outRangeColor = "#000000";
  fromSlider = undefined;
  toSlider = undefined;
  fromInput = undefined;
  toInput = undefined;

  min = 0;
  max = 100;
  step = 1;

  from = 0;
  to = 100;

  constructor() {
    super();

    this.min = parseFloat(this.dataset["min"]) ?? this.min
    this.max = parseFloat(this.dataset["max"]) ?? this.max
    this.step = parseFloat(this.dataset["step"]) ?? this.step
    this.from = parseFloat(this.dataset["from"]) ?? this.min
    this.to = parseFloat(this.dataset["to"]) ?? this.max

    this.fromSlider = this.querySelector('input[type="range"].from');
    this.fromSlider.min = this.min;
    this.fromSlider.max = this.max;
    this.fromSlider.step = this.step;
    this.fromSlider.value = this.from;

    this.toSlider = this.querySelector('input[type="range"].to');
    this.toSlider.min = this.min;
    this.toSlider.max = this.max;
    this.toSlider.step = this.step;
    this.toSlider.value = this.to;

    this.fromInput = this.querySelector('input[type="number"].from');
    this.fromInput.min = this.min;
    this.fromInput.max = this.max;
    this.fromInput.step = this.step;
    this.fromInput.value = this.from;

    this.toInput = this.querySelector('input[type="number"].to');
    this.toInput.min = this.min;
    this.toInput.max = this.max;
    this.toInput.step = this.step;
    this.toInput.value = this.to;

    this.fillSlider(this.fromSlider, this.toSlider);
    this.setToggleAccessible(this.toSlider);

    this.fromSlider.oninput = () => this.controlFromSlider();

    this.toSlider.oninput = () => this.controlToSlider();

    this.fromInput.oninput = () => this.controlFromInput();

    this.toInput.oninput = () => this.controlToInput();

    this.updateValues();
  }

  updateValues() {
    this.fromSlider.value = this.from;
    this.fromInput.value = this.from;
    this.toSlider.value = this.to;
    this.toInput.value = this.to;
  }

  updateValuesInput() {
    const [from, to] = this.getParsed(this.fromInput, this.toInput);
    this.from = Math.min(from, to);
    this.to = Math.max(to, from);
    this.updateValues();
  }

  updateValuesSlider() {
    const [from, to] = this.getParsed(this.fromSlider, this.toSlider);
    this.from = Math.min(from, to);
    this.to = Math.max(to, from);
    this.updateValues();
  }

  controlFromInput() {
    this.updateValuesInput();
    this.fillSlider(this.fromInput, this.toInput);
  }

  controlToInput() {
    this.updateValuesInput();
    this.fillSlider(this.fromInput, this.toInput);
    this.setToggleAccessible(this.toInput);
  }

  controlFromSlider() {
    this.updateValuesSlider();
    this.fillSlider(this.fromSlider, this.toSlider);
  }

  controlToSlider() {
    this.updateValuesSlider();
    this.fillSlider(this.fromSlider, this.toSlider);
    this.setToggleAccessible(this.toSlider);
  }

  getParsed(currentFrom, currentTo) {
    const from = parseFloat(currentFrom.value, 10);
    const to = parseFloat(currentTo.value, 10);
    return [from, to];
  }

  fillSlider(from, to) {
    const rangeDistance = to.max - to.min;

    // Left most value. When moving it, can only go as far as to
    const fromPosition = Math.min(from.value, to.value) - to.min

    // Rightmost value. When moving it, can only go as low 
    const toPosition = Math.max(to.value, from.value) - to.min

    this.toSlider.style.background = `linear-gradient(
      to right,
      ${this.inRangeColor} 0%,
      ${this.inRangeColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${this.outRangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${this.outRangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${this.inRangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${this.inRangeColor} 100%)`;

    this.fromInput.parentElement.style.left = `calc(${fromPosition / rangeDistance * 100}% - 18px)`
    this.toInput.parentElement.style.left = `calc(${toPosition / rangeDistance * 100}% - 18px)`
  }

  setToggleAccessible(currentTarget) {
    const toSlider = this.querySelector('input[type="range"].to');
    if (Number(currentTarget.value) <= 0) {
      toSlider.style.zIndex = 2;
    } else {
      toSlider.style.zIndex = 0;
    }
  }

}

customElements.define('double-range', DoubleRange);

// Aplica el filtrado por stock/mercado sobre el filtro nativo de Tallas en
// cuanto carga la pagina (cubre por ejemplo un enlace compartido con
// ?filter.v.option.tallas=... ya en la URL). En ese primer pase puede que
// window.sucursalActiva aun sea el valor por defecto ("WEB") porque la
// geolocalizacion de geoloc-inventory.js es asincrona; en cuanto esa
// geolocalizacion resuelve el mercado real, geoloc-inventory.js vuelve a
// llamar a window.applyMarketStockToGrid() para recalcular con el mercado
// correcto.
document.addEventListener('DOMContentLoaded', () => {
  if (window.applyMarketStockToGrid) window.applyMarketStockToGrid();
  if (window.updateVisibleProductCount) window.updateVisibleProductCount();

  // Revela el grid que sections/main-collection-product-grid(-tiles).liquid
  // dejo oculto con CSS (clase "talla-stock-pending" en <html>) cuando la
  // URL ya trae una talla seleccionada. Esperamos a que geoloc-inventory.js
  // resuelva el mercado real (evento "sucursalActivaResolved") para no
  // mostrar primero productos que luego desaparezcan; si la geolocalizacion
  // no responde (permiso denegado, sin soporte, etc.) revelamos igualmente
  // pasado un margen corto para no dejar la pagina en blanco.
  if (document.documentElement.classList.contains('talla-stock-pending')) {
    let fallbackTimeoutId = null;
    const revealGrid = () => {
      if (fallbackTimeoutId) clearTimeout(fallbackTimeoutId);
      if (window.applyMarketStockToGrid) window.applyMarketStockToGrid();
      if (window.updateVisibleProductCount) window.updateVisibleProductCount();
      document.documentElement.classList.remove('talla-stock-pending');
    };
    if (window.sucursalActivaResolved) {
      revealGrid();
    } else {
      window.addEventListener('sucursalActivaResolved', revealGrid, { once: true });
      fallbackTimeoutId = setTimeout(revealGrid, 1800);
    }
  }
});